import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, DELETE_ROW, JSON_KEY_CODE, UPDATE_ROW, 
   // JSON_KEY_ID, TABLE_HEADER_ID,  
   TABLE_HEADER_TR_CAN_MATCH,       TABLE_HEADER_TR_ORDER_ENTRY,      TABLE_HEADER_TR_ORDER_AMEND,      
   TABLE_HEADER_TR_ORDER_WITHDRAW,  TABLE_HEADER_TR_BETTER_PRICE,     TABLE_HEADER_TR_BETTER_QUANTITY,
   TABLE_HEADER_TR_REF_PRICE_CHECK, TABLE_HEADER_TR_REF_PRICE_PERCENT,TABLE_HEADER_TR_TRADING_ACCOUNT,
   TABLE_HEADER_TR_HOLDINGS,
   TABLE_HEADER_TR_OT_LIMIT,        TABLE_HEADER_TR_OT_MARKET,        TABLE_HEADER_TR_OT_HIDDEN,
   TABLE_HEADER_TR_OT_FOK,          TABLE_HEADER_TR_DURATION_IMMEDIATE,TABLE_HEADER_TR_DURATION_DAY,
   TABLE_HEADER_TR_DURATION_GTC,    TABLE_HEADER_TR_LOAD_DB_ORDERS,   TABLE_HEADER_TR_MIN_VALUE,
   TABLE_HEADER_TR_MAX_VALUE,       TABLE_HEADER_TR_HIDDEN_QTY_PERCENT,TABLE_HEADER_TR_AUCTION_START,
   TABLE_HEADER_TR_AUCTION_END,     JSON_KEY_TR_CAN_MATCH,            JSON_KEY_TR_ORDER_ENTRY,
   JSON_KEY_TR_ORDER_AMEND,         JSON_KEY_TR_ORDER_WITHDRAW,       JSON_KEY_TR_BETTER_PRICE,
   JSON_KEY_TR_BETTER_QUANTITY,     JSON_KEY_TR_REF_PRICE_CHECK,      JSON_KEY_TR_REF_PRICE_PERCENT,
   JSON_KEY_TR_TRADING_ACCOUNT,     JSON_KEY_TR_HOLDINGS,
   // JSON_KEY_TR_CASH_LIMIT,        TABLE_HEADER_TR_CASH_LIMIT,
   JSON_KEY_TR_OT_LIMIT,             JSON_KEY_TR_OT_MARKET,
   JSON_KEY_TR_OT_HIDDEN,           JSON_KEY_TR_OT_FOK,               JSON_KEY_TR_DURATION_IMMEDIATE,
   JSON_KEY_TR_DURATION_DAY,        JSON_KEY_TR_DURATION_GTC,         JSON_KEY_TR_LOAD_DB_ORDERS,
   JSON_KEY_TR_MIN_VALUE,           JSON_KEY_TR_MAX_VALUE,            JSON_KEY_TR_HIDDEN_QTY_PERCENT,
   JSON_KEY_TR_AUCTION_START,       JSON_KEY_TR_AUCTION_END,
   DROPDOWN_LIST_NONE, TABLE_HEADER_DESCRIPTION, JSON_KEY_DESCRIPTION, AddItemToDropdown, TABLE_HEADER_CODE,
   FormatWithDecimals,
   TABLE_HEADER_TR_AUCTION_TYPE,
   JSON_KEY_TR_AUCTION_TYPE,
   TABLE_HEADER_TR_DUMP_TABLES,
   JSON_KEY_TR_DUMP_TABLES,
   // TABLE_HEADER_ID,
   // JSON_KEY_ID,
   ConvertTable,
   JSON_KEY_TR_PRE_FUNCTION,
   JSON_KEY_TR_POST_FUNCTION,
   TABLE_HEADER_TR_POST_FUNCTION,
   TABLE_HEADER_TR_PRE_FUNCTION,
   TABLE_HEADER_TR_DELETE_REDUNDANT_ORDERS,
   JSON_KEY_TR_DELETE_REDUNDANT_ORDERS,
   JSON_KEY_TR_CHECKPOINT,
   TABLE_HEADER_TR_CHECKPOINT,
   ConvertCheckPointToName,
   JSON_KEY_TR_OT_SESSION,
   JSON_KEY_TR_OT_TRIGGER,
   TABLE_HEADER_TR_OT_SESSION,
   TABLE_HEADER_TR_OT_TRIGGER,
   JSON_KEY_TR_SESSION_TYPE,
   TABLE_HEADER_TR_SESSION_TYPE,
   JSON_KEY_TR_DURATION_SESSION,
   TABLE_HEADER_TR_DURATION_SESSION,
   instrumentCodeColor,
   statusTextColor,
   JSON_KEY_STATUS} 
from '../../common/common';
// import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { ConvertFromAuctionType, ConvertFromSessionType, ConvertToHoldingsValueName, ConvertToTradingRulesValueName } from '../../common/convert_functions';
import TradingRulesAdminForm from '../forms/trading_rules_admin_form';
import { addTradingRules } from '../../redux/dropDownSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';


const  TradingRules = () => {
   const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownTradingRulesData, setDropDownTradingRulesData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);

   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[ TradingRulesTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[ TradingRulesTable] Row Double Clicked:`, rowData);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log("trading rules: ", details.data);
      const { cm, oe, oa, ow, bp, bq, rpc, rpp, ta, unc, hld, cl, otl, otm, oth, otf, di, dd, dg, ldb, cp, minv, maxv, hqp, pre, post, dro, as, ae, ottr, ots, st, at, dt, ds } = details.data;

      const raw = details.data;
      const formatted = {
         ...raw,
         id   : raw.id,
         code : raw.code,
         cm   : ConvertToTradingRulesValueName(cm),
         oe   : ConvertToTradingRulesValueName(oe),
         oa   : ConvertToTradingRulesValueName(oa),
         ow   : ConvertToTradingRulesValueName(ow),
         bp   : ConvertToTradingRulesValueName(bp),
         bq   : ConvertToTradingRulesValueName(bq),
         rpc  : ConvertToTradingRulesValueName(rpc),
         ta   : ConvertToTradingRulesValueName(ta),
         unc  : ConvertToTradingRulesValueName(unc),
         hld  : ConvertToHoldingsValueName(hld),
         cl   : ConvertToTradingRulesValueName(cl),
         otl  : ConvertToTradingRulesValueName(otl),
         otm  : ConvertToTradingRulesValueName(otm),
         oth  : ConvertToTradingRulesValueName(oth),
         otf  : ConvertToTradingRulesValueName(otf),
         di   : ConvertToTradingRulesValueName(di),
         ds   : ConvertToTradingRulesValueName(ds),
         dd   : ConvertToTradingRulesValueName(dd),
         dg   : ConvertToTradingRulesValueName(dg),
         ldb  : ConvertToTradingRulesValueName(ldb),
         cp   : ConvertCheckPointToName(cp),
         dro  : ConvertToTradingRulesValueName(dro),
         as   : ConvertToTradingRulesValueName(as),
         ae   : ConvertToTradingRulesValueName(ae),
         ots  : ConvertToTradingRulesValueName(ots),
         ottr : ConvertToTradingRulesValueName(ottr),
         at   : ConvertFromAuctionType(at),
         st   : ConvertFromSessionType(st),
         dt   : ConvertTable(dt),
         pre  : pre,
         post : post,
         rpp  : rpp != null ? FormatWithDecimals(rpp, 0) + '%' : '',
         minv : minv != null ? FormatWithDecimals(minv, 0) : '',
         maxv : maxv != null ? FormatWithDecimals(maxv, 0) : '',
         hqp  : hqp != null ? FormatWithDecimals(hqp, 0) + '%' : '',

      };
   
      switch (details.type) {
         case ADD_ROW: {
            setLocalTableData(prev => {
               const isDuplicate = prev.some(row => row.id === formatted.id);
               if (isDuplicate) {
                  console.log(`[TradingRulesTable] Duplicate row ignored:`, formatted.id);
                  return prev;
               }
   
               return [...prev, formatted];
            });

            // console.log('setDropDownTradingRulesData: ', details.data.code);
            dispatch(addTradingRules({ id: formatted.code, name: formatted.code })); // Add for drop down lists
            AddItemToDropdown(setDropDownTradingRulesData, { id: details.data.code, name: details.data.code });
            
            break;
         }
   
         case UPDATE_ROW:
            // console.log('Trading Rules Update, details.data: ', details.data);
            setLocalTableData(prev => prev.map(row => row.id === formatted.id ? formatted : row));
            break;
   
         case DELETE_ROW:
            setLocalTableData(prev => prev.filter(row => row.id !== raw.code));
            break;
      
         default:
            break;
      }
   }, [setDropDownTradingRulesData, dispatch]);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);

   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID },  // don't show it but it is still there
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID },
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_TR_ORDER_ENTRY, accessor: JSON_KEY_TR_ORDER_ENTRY },
      { Header: TABLE_HEADER_TR_ORDER_AMEND, accessor: JSON_KEY_TR_ORDER_AMEND },
      { Header: TABLE_HEADER_TR_ORDER_WITHDRAW, accessor: JSON_KEY_TR_ORDER_WITHDRAW },
      { Header: TABLE_HEADER_TR_OT_LIMIT, accessor: JSON_KEY_TR_OT_LIMIT },
      { Header: TABLE_HEADER_TR_OT_MARKET, accessor: JSON_KEY_TR_OT_MARKET },
      { Header: TABLE_HEADER_TR_OT_HIDDEN, accessor: JSON_KEY_TR_OT_HIDDEN },
      { Header: TABLE_HEADER_TR_OT_FOK, accessor: JSON_KEY_TR_OT_FOK },
      { Header: TABLE_HEADER_TR_OT_SESSION, accessor: JSON_KEY_TR_OT_SESSION },
      { Header: TABLE_HEADER_TR_OT_TRIGGER, accessor: JSON_KEY_TR_OT_TRIGGER },
      { Header: TABLE_HEADER_TR_DURATION_IMMEDIATE, accessor: JSON_KEY_TR_DURATION_IMMEDIATE },
      { Header: TABLE_HEADER_TR_DURATION_SESSION, accessor: JSON_KEY_TR_DURATION_SESSION },
      { Header: TABLE_HEADER_TR_DURATION_DAY, accessor: JSON_KEY_TR_DURATION_DAY },
      { Header: TABLE_HEADER_TR_DURATION_GTC, accessor: JSON_KEY_TR_DURATION_GTC },
      { Header: TABLE_HEADER_TR_CAN_MATCH, accessor: JSON_KEY_TR_CAN_MATCH },
      { Header: TABLE_HEADER_TR_TRADING_ACCOUNT, accessor: JSON_KEY_TR_TRADING_ACCOUNT },
      { Header: TABLE_HEADER_TR_HOLDINGS, accessor: JSON_KEY_TR_HOLDINGS },
      { Header: TABLE_HEADER_TR_REF_PRICE_CHECK, accessor: JSON_KEY_TR_REF_PRICE_CHECK },
      { Header: TABLE_HEADER_TR_REF_PRICE_PERCENT, accessor: JSON_KEY_TR_REF_PRICE_PERCENT },
      { Header: TABLE_HEADER_TR_MIN_VALUE, accessor: JSON_KEY_TR_MIN_VALUE },
      { Header: TABLE_HEADER_TR_MAX_VALUE, accessor: JSON_KEY_TR_MAX_VALUE },
      { Header: TABLE_HEADER_TR_HIDDEN_QTY_PERCENT, accessor: JSON_KEY_TR_HIDDEN_QTY_PERCENT },
      { Header: TABLE_HEADER_TR_BETTER_PRICE, accessor: JSON_KEY_TR_BETTER_PRICE },
      { Header: TABLE_HEADER_TR_BETTER_QUANTITY, accessor: JSON_KEY_TR_BETTER_QUANTITY },
      { Header: TABLE_HEADER_TR_DELETE_REDUNDANT_ORDERS, accessor: JSON_KEY_TR_DELETE_REDUNDANT_ORDERS },
      { Header: TABLE_HEADER_TR_AUCTION_START, accessor: JSON_KEY_TR_AUCTION_START },
      { Header: TABLE_HEADER_TR_AUCTION_END, accessor: JSON_KEY_TR_AUCTION_END },
      { Header: TABLE_HEADER_TR_AUCTION_TYPE, accessor: JSON_KEY_TR_AUCTION_TYPE },
      { Header: TABLE_HEADER_TR_SESSION_TYPE, accessor: JSON_KEY_TR_SESSION_TYPE },
      { Header: TABLE_HEADER_TR_PRE_FUNCTION, accessor: JSON_KEY_TR_PRE_FUNCTION },
      { Header: TABLE_HEADER_TR_POST_FUNCTION, accessor: JSON_KEY_TR_POST_FUNCTION },
      { Header: TABLE_HEADER_TR_LOAD_DB_ORDERS, accessor: JSON_KEY_TR_LOAD_DB_ORDERS },
      { Header: TABLE_HEADER_TR_DUMP_TABLES, accessor: JSON_KEY_TR_DUMP_TABLES },
      { Header: TABLE_HEADER_TR_CHECKPOINT, accessor: JSON_KEY_TR_CHECKPOINT},

      // { Header: TABLE_HEADER_TR_UNCROSSING, accessor: JSON_KEY_TR_UNCROSSING },
      // { Header: TABLE_HEADER_TR_CASH_LIMIT, accessor: JSON_KEY_TR_CASH_LIMIT },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="TradingRulesTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
         />
         <Modal show={showForm} onHide={handleCloseForm}>
            <TradingRulesAdminForm rowData={selectedRow} onClose={handleCloseForm} tradingRulesOptions={dropDownTradingRulesData} />
         </Modal>
      </>
   );
};

export default  TradingRules;
